import * as React from 'react';

/**
 * Splits a given text into lines and inserts line breaks (`<br />`) between them.
 *
 * @param text - The input string to be processed. If undefined or empty, returns `null`.
 * @returns A React fragment containing the text split into lines with `<br />` elements
 *          inserted between them, or `null` if the input is not provided.
 */
export const withLineBreaks = (text?: string) => {
	if (!text) return null;

	const lines = text.split('\n');
	return lines.map((line, idx) => (
		<React.Fragment key={idx}>
			{line}
			{idx < lines.length - 1 && <br />}
		</React.Fragment>
	));
};
